import { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Pagination, { PagiSearch } from "../components/Pagination";
import { getApiSetting, postApiSetting, typeFloatNumber, typeNumber } from "../assets/functions";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import ToggleSwitch from "../components/ToggleSwitch";
import { TableStatusRow, StatusBadge } from "../components/UI";
export default function PayinWallet({setAuth}) {

      const [checked, setChecked] = useState(false
        // status ? true : false
     );
    
      const handleToggle = () => {
        setChecked((prev) => !prev);
      };

 const navigate = useNavigate();
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const { register: register2, handleSubmit: handleSubmit2, reset: reset2, formState: { errors: errors2 } } = useForm();

    const walletIdRef = useRef()
    const closeLMModalRef = useRef()

    const [createWalletData, setCreateWalletData] = useState([]);
    const [startOffset, setStartOffset] = useState(0);
    const [search, setSearch] = useState('');
    const [tableDataStatus, setTableDataStatus] = useState('');
    const [refreshTable, setRefreshTable] = useState(false);

    const [loadMoneyData, setLoadMoneyData] = useState([]);
    const [loadMoneyDataDupe, setLoadMoneyDataDupe] = useState([]);
    const [startOffset2, setStartOffset2] = useState(0);
    const [search2, setSearch2] = useState('');
    const [tableDataStatus2, setTableDataStatus2] = useState('');
    const [refreshTable2, setRefreshTable2] = useState(false);

    const [walletIdList, setWalletIdList] = useState([]);
    const [loadMoneyModalData, setLoadMoneyModalData] = useState({});

    const itemsPerPage = 10;
    const searchData = createWalletData.filter(item => Object.values(item).join("").toString().toLowerCase().includes(search.toLowerCase()))
    const endOffset = startOffset + itemsPerPage;
    const currentItems = searchData.slice(startOffset, endOffset)
    const pageCount = Math.ceil(searchData.length / itemsPerPage)

    const itemsPerPage2 = 10;
    const searchData2 = loadMoneyData.filter(item => Object.values(item).join("").toString().toLowerCase().includes(search2.toLowerCase()))
    const endOffset2 = startOffset2 + itemsPerPage2;
    const currentItems2 = searchData2.slice(startOffset2, endOffset2)
    const pageCount2 = Math.ceil(searchData2.length / itemsPerPage2)

    useEffect(() => {
        console.log("pageCount2-->",pageCount2)
        console.log("pageCount-->",pageCount)
        // console.log("currentItems-->",currentItems)
        console.log("endoffset-->",endOffset)
        setTableDataStatus('Loading...');
        (async () => {
            try {
                let res = await fetch('/Admin/api/AdminPayin/getAllWallet', getApiSetting());
                let result = (res.status === 200) ? await res.json(): "";
                // console.log(res)
                console.log("result---",result)
                if (res.status === 200) {
                    if (result.data.length < 1) {
                        setTableDataStatus('Not Found')
                    } else {
                        setTableDataStatus('')
                        setCreateWalletData(result.data)
                        console.log("createwalletData-->",createWalletData)
                    }
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) {
                console.log(error)
            }
        })()
    }, [refreshTable])

    useEffect(() => {
        setTableDataStatus2('Loading...');
        (async () => {
            try {
                let res = await fetch('/Admin/api/AdminPayin/fetchFundDepositeRequest', getApiSetting());
                let result = await res.json();
                // console.log(res)
                // console.log("result---",result)
                if (res.status === 200) {
                    if (result.data.responseData.length < 1) {
                        setTableDataStatus2('Not Found')
                    } else {
                        setTableDataStatus2('')
                        setLoadMoneyData(result.data.responseData)
                        setLoadMoneyDataDupe(result.data.responseData)
                    }
                }
                 else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
            } catch (error) {
                console.log(error)
            }
        })()
    }, [refreshTable2])

    const submitCreateWalletForm = async (data) => {
        // console.log(data)
        let settings = postApiSetting(data)
        try {
            let res = await fetch('/Admin/api/AdminPayin/createWallet', settings);
            let result = await res.json();
            // console.log(res)
            // console.log(result)
            if(res.status == 200)
            {
                let data = JSON.parse(result.data)
                if (data.responseCode === '00') {
                    reset()
                    alert('SUCCESS : ' + data.responseMsg)
                    setRefreshTable(refresh => !refresh)
                } else {
                    alert('FAILED : ' + data.responseMsg)
                }
            }
            else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }

        } catch (error) {
            console.log(error)
        }
    }

    const walletSwitch = async (status, data) => {
        console.log("e-->",status)
        console.log("data-->",data)
        try {
            let action = status === 'Active' ? 'Deactive':'Active';
            console.log("data---",data)
            let [, , , ,mid , , , , userId, walletId,] = data;
            // console.log({ action, mid, userId, walletId })
            let settings = postApiSetting({ action, mid, userId, walletId });
            let res = await fetch('/Admin/api/AdminPayin/updateWalletStatus', settings);
            let result = await res.json();
            // console.log(res)
            // console.log(result)
            if (res.status !== 200) {
                if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
                }
            } else {
                if (result.data.responseCode === '00') {
                    alert('SUCCESS : ' + result.data.responseMsg)
                } else {
                    alert('FAILED : ' + result.data.responseMsg)
                }
                setRefreshTable(refresh => !refresh)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const submitLoadMoneyForm = async (data) => {
        let creditWalletId = walletIdRef.current.value;
        if(!creditWalletId){
            alert('FAILED : Wallet id not found !')
            return false;
        }
        // console.log({...data,creditWalletId})
        let settings = postApiSetting({...data,creditWalletId})
        try {
            let res = await fetch('/Admin/api/AdminPayin/fundDeposite', settings);
            let result = await res.json();
            // console.log(res)
            // console.log(result)
            if (res.status !== 200) {
                if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            } else {
                let data = JSON.parse(result.data)
                if (data.responseCode === '00') {
                    reset2()
                    alert('SUCCESS : ' + data.responseMsg)
                    setRefreshTable2(refresh => !refresh)
                } else {
                    alert('FAILED : ' + data.responseMsg)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const fetchWalletId = async () => {
        try {
            let userId = document.querySelector('._userid').value;
            let mid = document.querySelector('._mid').value;
            if(userId && mid){
                let settings = postApiSetting({mid,userId});
                let res = await fetch('/Admin/api/AdminPayin/fetchWalletId', settings);
                let result =(res.status === 200) ? await res.json(): "";
                // console.log(res)
                // console.log(result)
                if (res.status !== 200) {

                     if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
                } else {
                 
                    if (result.data.responseCode === '00') {
                        if(result.data.responseData.length > 0){
                            alert('SUCCESS : ' + result.data.responseMsg)
                            setWalletIdList(result.data.responseData)
                        }else{
                            alert('FAILED : ' + 'Wallet Id Not Found')
                            setWalletIdList([])
                        }
                    } else {
                        alert('FAILED : ' + result.data.responseMsg)
                        setWalletIdList([])
                    }
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const showWalletModal = (id) => {
        let targetObj = currentItems2.filter(item => item.id === id)[0]
        let newTargetObj = {...targetObj,creditAmount:targetObj.creditAmount/100}
        // console.log(newTargetObj)
        setLoadMoneyModalData(newTargetObj)
    }

    const loadMoneyAction = async (action) => {
        let {id,userId,mid,creditWalletId,creditTxnId} = loadMoneyModalData;
        let creditAmount = (loadMoneyModalData.creditAmount*100).toString();
        let settings = postApiSetting({id,userId,mid,creditWalletId,creditAmount,creditTxnId,action})
        try {
            let res = await fetch('/Admin/api/AdminPayin/aprFundDeposite', settings);
            // console.log(res)
            // console.log(result)
            let result =(res.status === 200) ? await res.json(): "";
            if (res.status !== 200) {
                 result = await res.json();
                 if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            } else {
                if (result.data.responseCode === '00') {
                    alert('SUCCESS : ' + result.data.responseMsg)
                } else {
                    alert('FAILED : ' + result.data.responseMsg)
                }
                setRefreshTable2(refresh => !refresh)
                closeLMModalRef.current.click();
            }
        } catch (error) {
            console.log(error)
        }
    }

    const loadMoneyStatusFilter = (e) => {
        let fltrData = [];
        let creditStatus = e.target.value;
        if(creditStatus === 'All'){
            fltrData = loadMoneyDataDupe;
        }else{
            fltrData = loadMoneyDataDupe.filter(item => item.creditStatus === creditStatus)
        }
        if(fltrData.length < 1){
            setTableDataStatus2('Not Found')
        }
        setLoadMoneyData(fltrData)
    }

    // console.log(loadMoneyModalData)

    return (<>
        {/* <SidebarNavigation /> */}
        <ToastContainer />
        <section className="transaction-page">
            <Navbar title="WALLET" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">Payin Wallet</h6>

                    <ul className="nav nav-tabs wallet-tabs" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" data-bs-toggle="tab" href="#createwallet">CREATE WALLET</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" data-bs-toggle="tab" href="#loadmoney">LOAD MONEY</a>
                        </li>
                    </ul>

                    <div className="tab-content">

                        <div id="createwallet" className="container tab-pane active">
                            <form className="cw-form my-4" onSubmit={handleSubmit(submitCreateWalletForm)}>
                                <div className="row">
                                    <div className="col-md-3 mb-2">
                                        <label className="form-label">User Id <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none"
                                            {...register('userId', { required: { value: true, message: "This field is required" } })} />
                                        {errors.userId && <strong className="text-danger"><small>{errors.userId.message}</small></strong>}
                                    </div>
                                    <div className="col-md-3 mb-2">
                                        <label className="form-label">Mid <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                            {...register('mid', { required: { value: true, message: "This field is required" } })} />
                                        {errors.mid && <strong className="text-danger"><small>{errors.mid.message}</small></strong>}
                                    </div>
                                    <div className="col-md-3 mb-2">
                                        <label className="form-label">Wallet Max Limit <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                            {...register('maxWalletLimit', { required: { value: true, message: "This field is required" } })} />
                                        {errors.maxWalletLimit && <strong className="text-danger"><small>{errors.maxWalletLimit.message}</small></strong>}
                                    </div>
                                    <div className="col-sm-3">
                                        <button type="submit" className="btn btn-sm _themebg-0 text-white">
                                            <i className="fas fa-plus"></i> Submit</button>
                                    </div>
                                </div>
                            </form>

                            <PagiSearch setSearch={setSearch}
                                totalEntries={searchData.length}
                                setStartOffset={setStartOffset}
                                setTableDataStatus={setTableDataStatus} />

                            <div className="table-responsive my-2 com-table">
                                <table className="table table-bordered mb-1">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>User Id</th>
                                            <th>Mid</th>
                                            <th>Wallet Id</th>
                                            <th>Previous Balance</th>
                                            <th>Available Balance</th>
                                             <th>Max Wallet Limit</th>
                                            <th>Creation Date</th>
                                            <th>Modification Date</th>
                                            <th>Wallet Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.length < 1 ? <TableStatusRow colSpan={11} status={tableDataStatus} /> :
                                            currentItems.map((item, index) => {
                                                return (
                                                    <tr key={startOffset + index}>
                                                        <td>{startOffset + index + 1}</td>
                                                        <td>{item[8]}</td>
                                                        <td>{item[4]}</td>
                                                        <td>{item[9]}</td>
                                                        <td>{item[6]/100}</td>
                                                        <td>{item[1]/100}</td>
                                                        <td>{item[3]/100}</td>
                                                        <td>{item[2]}</td>
                                                        <td>{item[5]}</td>
                                                        <td><StatusBadge status={item[7]} /></td>
                                                         {/* <td>{item[10]/100}</td> */}
                                                        <td>
                                                            {/* <label className={`switch-btn ${item[6] == 'Active' ? 'active' : ''}`}>
                                                                <input type="checkbox" defaultChecked={item[6] == 'Active' ? true : false} onChange={(e) => walletSwitch(e, item)} />
                                                                <span className="slider round d-flex justify-content-between align-items-center px-2">
                                                                    <samp>ON</samp>
                                                                    <samp>OFF</samp>
                                                                </span>
                                                            </label> */}
                                                            <div onClick={() => {
                                                                console.log("Toggle clicked", item[7], item);
                                                                walletSwitch(item[7], item);
                                                            }}>
                                                            
                                                            <ToggleSwitch status={item[7]==="Active"} setChecked={setChecked} handleToggle={handleToggle} checked={item[7]==="Active"}
                                                            //  onClick={()=>walletSwitch(item[6],item)}
                                                            />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                    </tbody>
                                </table>
                            </div>

                            <Pagination setStartOffset={setStartOffset}
                                pageCount={pageCount} itemsPerPage={itemsPerPage} />
                        </div>

                        <div id="loadmoney" className="container tab-pane fade">
                            <form className="lw-form my-4" onSubmit={handleSubmit2(submitLoadMoneyForm)}>
                                <div className="row">
                                    <div className="col-md-6 col-lg-3 mb-2">
                                        <label className="form-label">User Id <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _userid" onInput={fetchWalletId}
                                            {...register2('userId', { required: { value: true, message: "This field is required" } })} />
                                        {errors2.userId && <strong className="text-danger"><small>{errors2.userId.message}</small></strong>}
                                    </div>
                                    <div className="col-md-6 col-lg-3 mb-2">
                                        <label className="form-label">Mid <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none _mid" onInput={(e)=>{typeNumber(e);fetchWalletId()}}
                                            {...register2('mid', { required: { value: true, message: "This field is required" } })} />
                                        {errors2.mid && <strong className="text-danger"><small>{errors2.mid.message}</small></strong>}
                                    </div>
                                    <div className="col-md-6 col-lg-3 mb-2">
                                        <label className="form-label">Wallet Id <strong className='text-danger'>*</strong></label>
                                        <select className="form-select shadow-none" ref={walletIdRef}>
                                            <option value="">--Select--</option>
                                            {walletIdList.map((item,index) => <option key={index} value={item}>{item}</option> )}
                                        </select>
                                        {/* {walletIdList.length < 1 && <strong className="text-danger"><small>Not Found</small></strong>} */}
                                    </div>
                                    <div className="col-md-6 col-lg-3 mb-2">
                                        <label className="form-label">Credit Type <strong className='text-danger'>*</strong></label>
                                        <select className="form-select shadow-none" {...register2('creditType',
                                            { required: { value: true, message: "This field is required" } })} >
                                            <option value="">--Select--</option>
                                            <option value="UserCredit">USER CREDIT</option>
                                            <option value="VaCredit">VA CREDIT</option>
                                            <option value="PayinCredit">PAYIN CREDIT</option>
                                        </select>
                                        {errors2.creditType && <strong className="text-danger"><small>{errors2.creditType.message}</small></strong>}
                                    </div>
                                    <div className="col-md-6 col-lg-3 mb-2">
                                        <label className="form-label">Amount <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" onInput={typeFloatNumber}
                                            {...register2('creditAmount', { required: { value: true, message: "This field is required" } })} />
                                        {errors2.creditAmount && <strong className="text-danger"><small>{errors2.creditAmount.message}</small></strong>}
                                    </div>
                                    <div className="col-md-6 col-lg-3 mb-2">
                                        <label className="form-label">UTR <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none" onInput={typeNumber}
                                            {...register2('utr', { required: { value: true, message: "This field is required" } })} />
                                        {errors2.utr && <strong className="text-danger"><small>{errors2.utr.message}</small></strong>}
                                    </div>
                                    <div className="col-md-6 col-lg-3 mb-2">
                                        <label className="form-label">Credit Mode <strong className='text-danger'>*</strong></label>
                                        <select className="form-select shadow-none" {...register2('creditMode',
                                            { required: { value: true, message: "This field is required" } })} >
                                            <option value="">--Select--</option>
                                            <option value="IMPS">IMPS</option>
                                            <option value="NEFT">NEFT</option>
                                            <option value="RTGS">RTGS</option>
                                        </select>
                                        {errors2.creditMode && <strong className="text-danger"><small>{errors2.creditMode.message}</small></strong>}
                                    </div>
                                    <div className="col-md-6 col-lg-3 mb-2">
                                        <label className="form-label">Remark <strong className='text-danger'>*</strong></label>
                                        <input type="text" className="form-control shadow-none"
                                            {...register2('remark', { required: { value: true, message: "This field is required" } })} />
                                        {errors2.remark && <strong className="text-danger"><small>{errors2.remark.message}</small></strong>}
                                    </div>
                                    <div className="col-sm-3 mt-2">
                                        <button type="submit" className="btn _themebg-0 text-white">
                                            <i className="fas fa-plus"></i> Submit</button>
                                    </div>
                                </div>
                            </form>

                            <ul class="list-group list-group-horizontal mb-3">
                                <li class="list-group-item">
                                    <input class="form-check-input me-1 shadow-none" type="radio" name="creditStatus" value="All" id="fltrcheck_1" defaultChecked onChange={loadMoneyStatusFilter} />
                                    <label class="form-check-label" htmlFor="fltrcheck_1">ALL</label>
                                </li>
                                <li class="list-group-item">
                                    <input class="form-check-input me-1 shadow-none" type="radio" name="creditStatus" value="Pending" id="fltrcheck_2" onChange={loadMoneyStatusFilter} />
                                    <label class="form-check-label" htmlFor="fltrcheck_2">PENDING</label>
                                </li>
                                <li class="list-group-item">
                                    <input class="form-check-input me-1 shadow-none" type="radio" name="creditStatus" value="Rejected" id="fltrcheck_3" onChange={loadMoneyStatusFilter} />
                                    <label class="form-check-label" htmlFor="fltrcheck_3">REJECTED</label>
                                </li>
                                <li class="list-group-item">
                                    <input class="form-check-input me-1 shadow-none" type="radio" name="creditStatus" value="Approved" id="fltrcheck_4" onChange={loadMoneyStatusFilter} />
                                    <label class="form-check-label" htmlFor="fltrcheck_4">APPROVED</label>
                                </li>
                            </ul>

                            <PagiSearch setSearch={setSearch2}
                                totalEntries={searchData2.length}
                                setStartOffset={setStartOffset2}
                                setTableDataStatus={setTableDataStatus2} />

                            <div className="table-responsive my-2 com-table">
                                <table className="table table-bordered mb-1">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Credit Txn Id</th>
                                            <th>Wallet Id</th>
                                            <th>User Id</th>
                                            <th>Mid</th>
                                            <th>Credit Status</th>
                                            <th>Previous Balance</th>
                                            <th>Current Balance</th>
                                            <th>Credit Amount</th>
                                            <th>UTR</th>
                                            <th>Credit Type</th>
                                            <th>Credit Mode</th>
                                            <th>Remark</th>
                                            <th>Creation Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems2.length < 1 ? <TableStatusRow colSpan={15} status={tableDataStatus2} /> :
                                            currentItems2.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{startOffset2 + index + 1}</td>
                                                        <td>{item.creditTxnId}</td>
                                                        <td>{item.creditWalletId}</td>
                                                        <td>{item.userId}</td>
                                                        <td>{item.mid}</td>
                                                        <td><StatusBadge status={item.creditStatus} /></td>
                                                        <td>{item.prevBalance/100}</td>
                                                        <td>{item.currentBalance/100}</td>
                                                        <td>{item.creditAmount/100}</td>
                                                        <td>{item.utr}</td>
                                                        <td>{item.creditType}</td>
                                                        <td>{item.creditMode}</td>
                                                        <td>{item.remark}</td>
                                                        <td>{item.creditDateTime}</td>
                                                        <td>
                                                            {/* <button type="button" className="btn btn-sm btn-success me-2" data-bs-toggle="modal" data-bs-target="#walletModal" onClick={()=>showWalletModal('Approved',item.id)}>Approve</button> */}
                                                            {/* <button type="button" className="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#walletModal" onClick={()=>showWalletModal('Rejected',item.id)}>Reject</button> */}
                                                            {item.creditStatus === 'Pending' ? 
                                                            <button type="button" className="btn btn-sm _themebg-0 text-white" data-bs-toggle="modal" data-bs-target="#walletModal" onClick={()=>showWalletModal(item.id)}>VIEW</button>
                                                            : ''}
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                    </tbody>
                                </table>
                            </div>

                            <Pagination setStartOffset={setStartOffset2}
                                pageCount={pageCount2} itemsPerPage={itemsPerPage2} />

                        </div>
                    </div>



                </div>
            </div>
        </section>

        <div className="modal fade" id="walletModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-6 ms-2 text-secondary" id="staticBackdropLabel">Load Money Data</h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body px-4 pt-4 pb-2">
                    <div className="row">
                        <div className="col-md-6">
                            <FloatInputBox name='Credit Txn Id' val={loadMoneyModalData.creditTxnId} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='Credit Wallet Id' val={loadMoneyModalData.creditWalletId} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='User Id' val={loadMoneyModalData.userId} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='MID' val={loadMoneyModalData.mid} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='Credit Status' val={loadMoneyModalData.creditStatus} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='Credit Amount' val={loadMoneyModalData.creditAmount} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='UTR' val={loadMoneyModalData.utr} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='Credit Type' val={loadMoneyModalData.creditType} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='Credit Mode' val={loadMoneyModalData.creditMode} />
                        </div>
                        <div className="col-md-6">
                            <FloatInputBox name='Remark' val={loadMoneyModalData.remark} />
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" ref={closeLMModalRef}>Close</button>
                    <button type="button" className="btn btn-danger" onClick={()=>loadMoneyAction('Rejected')}>Reject</button>
                    <button type="button" className="btn btn-success" onClick={()=>loadMoneyAction('Approved')}>Approve</button>
                </div>
                </div>
            </div>
        </div>

    </>)
}

const FloatInputBox = ({val,name}) => {
    return (
        <div className="form-floating mb-3">
            <input type="text" className="form-control" defaultValue={val} disabled />
            <label>{name}</label>
        </div>
    )
}